import { CASINO_CONFIG } from '@components/casino/casino.config';

export interface casinoLobbyCardType {
  id: number;
  name: string;
  path: string;
  provider: number;
  text: string;
  img: string;
  svgUrl?: string;
  key?: string;
  casinoD?: string;
  providerName?: 'ogzSlot' | 'vivo' | 'groupga' | 'evolution';
} // silinecek

export interface casinoGamesListApiType {
  page: number;
  limit: number;
  providerId: number | string;
  categoryId: number | string;
  searchValue?: string;
}

export type DebouncedFunction = (() => void) & { cancel: () => void };
export type DebouncedInputFunction = ((e: string) => void) & { cancel: () => void };
export type DebouncedProviderFunction = ((e: number) => void) & { cancel: () => void };

export interface casinoFavGamesListApiType {
  page: number;
  limit: number;
}

export interface casinoFavAddAndRemoveApiType {
  gameId: number;
  eventType: boolean;
}

export interface casinoMostFavoritesApiType {
  count: number;
}

export interface goGamesApiType {
  Success: boolean;
  Type: string;
  Data: string;
}

export type casinoDialogData = {
  openGameData: goGamesApiType;
  gameData: CasinoGameModel;
  providerData: CasinoGameListModel;
};

// Categori Model

export interface casinoLobbyMenuItemType {
  CategoryId: number;
  CategoryName: string;
}
export class CasinoCategoriesModel {
  categoryId: number;
  categoryName: string;
  categoryTranslateKey: string;
  constructor({ CategoryId, CategoryName }: casinoLobbyMenuItemType) {
    this.categoryId = CategoryId;
    this.categoryName = CategoryName;
    this.categoryTranslateKey = `casino.lobby.${CategoryName}`;
  }
}

export class CasinoCategoriesListModel {
  categoriesList: CasinoCategoriesModel[] = [];
  constructor(response?: casinoLobbyMenuItemType[]) {
    if (Array.isArray(response) && response.length > 0) {
      this.categoriesList = [
        new CasinoCategoriesModel({
          CategoryName: CASINO_CONFIG.categoriesAll.CategoryName,
          CategoryId: CASINO_CONFIG.categoriesAll.CategoryId,
        }),
        ...response.map((i: casinoLobbyMenuItemType) => new CasinoCategoriesModel(i)),
      ];
    }
  }
}

// Provider Model
export interface casinoLobbyCardIType {
  ProviderId: number;
  ProviderName: string;
  GameCount: number;
  Order: number;
}

export class CasinoProviderModel {
  providerId: number;
  providerName: string;
  gameCount: number;
  order: number;
  constructor({ ProviderId, ProviderName, GameCount, Order }: casinoLobbyCardIType) {
    this.providerId = ProviderId;
    this.providerName = ProviderName;
    this.gameCount = GameCount;
    this.order = Order;
  }
}

export class CasinoProviderListModel {
  providerList: CasinoProviderModel[] = [];
  constructor(response?: casinoLobbyCardIType[], providerAll?: { ProviderId: number; ProviderName: string }) {
    if (Array.isArray(response) && response.length > 0) {
      const totalCount = response.reduce((arr, acc) => {
        if (typeof acc.GameCount === 'number') {
          arr = arr + acc.GameCount;
        }

        return arr;
      }, 0);

      this.providerList = [
        new CasinoProviderModel({
          ProviderId: providerAll.ProviderId,
          ProviderName: providerAll.ProviderName,
          GameCount: totalCount,
          Order: totalCount,
        }),
        ...response.map((i: casinoLobbyCardIType) => new CasinoProviderModel(i)),
      ];
    }
  }
}

// Game Model
export interface casinoGamesItemType {
  Id: number;
  Name: string;
  Image: string;
  CategoryId: number;
  CategoryName: string;
  ProviderId: number;
  ProviderName: string;
  RowNumber: null | number;
  PlayedCount: number;
}

export class CasinoGameModel {
  id: number;
  name: string;
  image: string;
  categoryId: number;
  categoryName: string;
  providerId: number;
  providerName: string;
  rowNumber: null | number;
  playedCount: number;

  constructor({ Id, Name, Image, CategoryId, CategoryName, ProviderId, ProviderName, RowNumber, PlayedCount }: casinoGamesItemType) {
    this.id = Id;
    this.name = Name;
    this.image = Image;
    this.categoryId = CategoryId;
    this.categoryName = CategoryName;
    this.providerId = ProviderId;
    this.providerName = ProviderName;
    this.rowNumber = RowNumber;
    this.playedCount = PlayedCount;
  }

  public createDefaultImage(assetsPath: string): string {
    return `${assetsPath}${CASINO_CONFIG.defaultImageUrl}`;
  }

  public createErrorImage(assetsPath: string): string {
    return `${assetsPath}${CASINO_CONFIG.errorImageUrl}`;
  }
}

export class CasinoGameListModel {
  gameList: CasinoGameModel[] | [] = [];
  isDataAllowed = false;
  favList: number[] = [];
  constructor({ response, prevGameList, page, dataType }: { response?: casinoGamesItemType[]; prevGameList?: CasinoGameListModel; page?: number; dataType?: string }) {
    if (dataType === 'fav') {
      if (Array.isArray(response) && response.length > 0) {
        this.gameList = response.map((i: casinoGamesItemType) => {
          this.favList.push(i.Id);
          return new CasinoGameModel(i);
        });
        this.isDataAllowed = prevGameList?.isDataAllowed || false;
      } else {
        this.gameList = [];
        this.isDataAllowed = prevGameList?.isDataAllowed || false;
      }
    } else if (dataType === 'mostFavorites') {
      if (Array.isArray(response) && response.length > 0) {
        this.gameList = response.map((i: casinoGamesItemType) => new CasinoGameModel(i));
        this.isDataAllowed = false;
      } else {
        this.gameList = [];
        this.isDataAllowed = true;
      }
    } else {
      if (page > 1 && Array.isArray(prevGameList?.gameList) && prevGameList.gameList.length > 0) {
        if (Array.isArray(response) && response.length > 0) {
          this.gameList = [...prevGameList.gameList, ...response.map((i: casinoGamesItemType) => new CasinoGameModel(i))];
          this.isDataAllowed = prevGameList?.isDataAllowed;
        } else {
          this.isDataAllowed = true;
          this.gameList = prevGameList.gameList;
        }
      } else {
        if (Array.isArray(response) && response.length > 0) {
          this.gameList = response.map((i: casinoGamesItemType) => new CasinoGameModel(i));
          this.isDataAllowed = prevGameList?.isDataAllowed || false;
        } else {
          this.gameList = [];
          this.isDataAllowed = true;
        }
      }
    }
  }
}

export interface CasinoSliderApiType {
  DataType: number;
  Title: string;
  ImageDesktop: string;
  ImageMobile: string;
  Game?: casinoGamesItemType;
  URL: string;
  RouteId: string;
}

export class CasinoSliderItemModel {
  id: string;
  sliderType: number;
  imageUrl: string;
  gameData: CasinoGameModel;
  url: string;
  routeId: string;

  constructor({ RouteId, URL, Game, Title, DataType, ImageMobile, ImageDesktop }: CasinoSliderApiType, windowWidth: number) {
    this.id = Title;
    this.sliderType = DataType;
    this.url = URL;
    this.routeId = RouteId;
    this.imageUrl = windowWidth > 990 ? ImageDesktop : ImageMobile;
    if (Game?.Id) {
      this.gameData = new CasinoGameModel(Game);
    }
  }
}

export class CasinoSliderListModel {
  sliderBannerList: CasinoSliderItemModel[] = [];
  isMobile: boolean;
  constructor({ response, windowWidth }: { response?: CasinoSliderApiType[]; windowWidth: number }) {
    if (Array.isArray(response) && response.length > 0) {
      this.sliderBannerList = response.map((i: CasinoSliderApiType) => new CasinoSliderItemModel(i, windowWidth));
    } else {
      this.sliderBannerList = [];
    }
    this.isMobile = windowWidth > 990;
  }
}
